export const inputs = [
  {
    advanced: false,
    type: 'input',
    id: 'plate',
    label: 'Placa',
    placeholder: 'Placa',
    value: ''
  },
  {
    advanced: false,
    type: 'input',
    id: 'comments',
    label: 'Observação',
    placeholder: 'Observação',
    value: ''
  }
];